import React, { MouseEventHandler, useEffect, useState } from "react";
import H4 from "../../components/Typography/H4";
import { useFetchApi } from "../../hooks/useFetchApi";
import Modal from "../../components/Modal";
import { DndContext, 
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
    useDroppable,
    useDraggable, } from "@dnd-kit/core";
import { arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    verticalListSortingStrategy, } from "@dnd-kit/sortable";
import { SortableItem } from "./SortableItem";
import AdManagementModal from "./AdManagementModel";
import DeleteModal from "./DeleteModal";
import Button from "../../components/Button";

interface Ad {
  id: number;
  url: string;
  order_no: number;
  image: string;
  start_date: string;
  end_date: string;
  status: number;
  type: string;
}

const AdManagement: React.FC = () => {
  const [ads, setAds] = useState<Ad[]>([]);
  const [selectedAd, setSelectedAd] = useState<Ad | null | {}>(null);
  const [newAdd, toggle] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<string | number>("");
  const [previewImage, setPreviewImage] = useState<string>("");
  
  
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
    );
    
    const { response, loading, execute } = useFetchApi(
      "/api/ads",
      {},
      "GET"
      );
  const {execute: updateOrder} = useFetchApi("/api/ads-order", {}, "POST", execute);

  useEffect(() => {
    if (response && !loading) {
      setAds(response);
    }
  }, [response]);

  useEffect(() => {
    execute();
  }, []);

  const handlePreview = (ad: any) => {
    setPreviewImage(`data:${ad.type};base64,${ad.image}`);
  };

  const handleDragEnd = (event: any) => {
    const {active, over} = event;

    const activeOrderId = active.data.current.ad.order_no;
    const overOrderId = over.data.current.ad.order_no;
    if (active.data.current.ad.id !== over.id) {
      updateOrder({ads: ads.map((ad: Ad) => {
        if (ad.id === active.data.current.ad.id) {
          ad.order_no = overOrderId;
        }
        if (ad.id === over.data.current.ad.id) {
          ad.order_no = activeOrderId;
        }
        return {order_no: ad.order_no, id: ad.id}
      })})
    }
  }

  return (
    <div className="flex flex-col p-8 bg-white">
      <div className="flex justify-between mb-8 text-white">
        <H4>Ad Management</H4>
        <Button
          fontSize="small"
          onClick={() => {
            toggle(true);
          }}
          variant="primary"
        >
          Add New Ad
        </Button>
      </div>
      <DeleteModal data={{id: deleteId}} status={deleteId.toString().length ? true: false} onClose={() => {
        setDeleteId("")
      }} onSuccess={execute}/>
      <AdManagementModal
          ad={selectedAd}
          status={Object.keys(selectedAd || {}).length || newAdd ? true : false}
          onClose={() => {
            execute();
            setSelectedAd(null);
            toggle(false);
          }}
        />
      <Modal
        onClose={() => setPreviewImage("")}
        status={previewImage.length ? true : false}
      >
        <img src={previewImage} />
      </Modal>
      <DndContext 
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      {
        ads.length && (
        <SortableContext items={ads} strategy={verticalListSortingStrategy}>
      <table className="w-full">
        <thead>
          <tr>
            <th className="font-bold p-2 border-b">#</th>
            <th className="font-bold p-2 border-b">URL</th>
            <th className="font-bold p-2 border-b">Section</th>
            <th className="font-bold p-2 border-b">Order #</th>
            <th className="font-bold p-2 border-b">Ad Image</th>
            <th className="font-bold p-2 border-b">Actions</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {loading ? (
            <tr>
              <td colSpan={5}>Loading...</td>
            </tr>
          ) : (
            ads.map((ad: Ad, index: number) => (
              <SortableItem ad={ad} handlePreview={handlePreview} handleEdit={(ad: Ad) => setSelectedAd(ad)} handleDelete={(ad: Ad) => setDeleteId(ad.id)}/>
            ))
          )}
        </tbody>
      </table>
      
        </SortableContext>
        )
      }
      </DndContext>
    </div>
  );
};

export default AdManagement;
